/**
 * Mirrors CPHub.Data.Models.FedExRegistrationStatus enum values. Numeric because the API
 * serializes the enum as an int.
 */
export enum FedExRegistrationStatus {
    Pending = 0,
    Factor1Complete = 10,
    Factor2InProgress = 20,
    Registered = 30,
    PendingSupport = 40,
    /**
     * Per FedEx Integrator AGD, repeated Factor 2 failures lock MFA methods on the pharmacy's
     * account for 24 hours. UI should surface the lockout and prompt the user to try invoice
     * validation (if not yet tried) or contact FedEx Customer Service.
     */
    MfaLocked = 50,
    /** Turned off for this store. Child credentials cleared; EULA preserved. Re-register to turn back on. */
    Offboarded = 60,
}

/**
 * Factor 2 method string literals. Match CPHub.Data.Models.FedExFactor2Methods constants.
 */
export type FedExFactor2Method =
    | "Invoice"
    | "PhonePin"
    | "EmailPin"
    | "SmsPin"
    | "SupportEscalation";

export type FedExPinDeliveryMethod = "Phone" | "Email" | "Sms";

export interface FedExRegistrationStatusResponse {
    storeId: number;

    hasCurrentEulaAcceptance: boolean;
    latestEulaAcceptedByUserName: string | null;
    latestEulaAcceptedAt: string | null;
    latestEulaVersion: string | null;
    currentEulaVersion: string;

    registrationStatus: FedExRegistrationStatus;
    hasStoredChildCredentials: boolean;
    accountNumber: string | null;
    factor1CompletedAt: string | null;
    factor2Method: string | null;
    factor2CompletedAt: string | null;
    registeredAt: string | null;
    registrationNotes: string | null;

    isEnabled: boolean;
}

export interface FedExFactor1Request {
    accountNumber: string;
    customerName: string;
    streetLines: string | null;
    city: string | null;
    stateOrProvinceCode: string | null;
    postalCode: string | null;
    countryCode: string | null;
    residential: boolean;
}

export interface FedExRequestPinRequest {
    deliveryMethod: FedExPinDeliveryMethod;
}

export interface FedExSubmitPinRequest {
    pin: string;
}

export interface FedExSubmitInvoiceRequest {
    invoiceNumber: string;
    /** ISO-8601 date string (yyyy-MM-dd). Must be within the last 90 days per AGD. */
    invoiceDate: string;
    invoiceAmount: number;
    /** ISO 4217 currency code (e.g. USD, CAD, EUR). */
    currency: string;
}

export interface FedExEscalateSupportRequest {
    notes: string | null;
}

export interface FedExRotateCredentialsRequest {
    childKey: string;
    childSecret: string;
}
